import { UnreadIndicator } from '../redux/channels/unreadIndicator'

/** The MUI `Badge` props that render an `UnreadIndicator`. */
export interface IUnreadBadgeProps {
  badgeContent?: number
  variant: 'standard' | 'dot'
  invisible: boolean
}

/**
 * Render one unread indicator as a badge, the same way everywhere.
 *
 * `invisible` is passed explicitly rather than left to MUI: its default hides a
 * badge whose content is 0, which is exactly the case a dot has to survive —
 * a dot says "something is unread that counting would not describe", and zero
 * is the number it deliberately carries.
 */
export const toUnreadBadgeProps = (indicator: UnreadIndicator): IUnreadBadgeProps => {
  if (indicator.kind === 'number') {
    return { badgeContent: indicator.count, variant: 'standard', invisible: false }
  }
  return { variant: 'dot', invisible: indicator.kind === 'none' }
}

/** A plain count as an indicator, for badges that have no dot state of their own. */
export const countAsUnreadIndicator = (count: number): UnreadIndicator =>
  count > 0 ? { kind: 'number', count } : { kind: 'none' }
